import './ispinner.css';
import {Box} from "@mui/material";

const LoadingSpinner = (props) => {
    return (
        <Box className="ispinner" {...props}>
            <div className="ispinner-blade"></div>
            <div className="ispinner-blade"></div>
            <div className="ispinner-blade"></div>
            <div className="ispinner-blade"></div>
            <div className="ispinner-blade"></div>
            <div className="ispinner-blade"></div>
            <div className="ispinner-blade"></div>
            <div className="ispinner-blade"></div>
        </Box>
    )
}
export default LoadingSpinner;